import { Buffer } from "buffer";
import History from "../../@history/index";
import { encryptData } from "./encryptionService";

export const registerUser = async (user, apikey, allowedServiceOpt, token) => {
    let statusCode;
    let apiResponse;
    let orignalPassword = user.password;
    let originalallowedServiceOpt = user.allowedServiceOpt;
    user.Password = Buffer.from(user.Password).toString('base64');
    user.allowedServiceOpt = allowedServiceOpt;
    user.Email = user?.Email.toLowerCase()
    const requestOptions = {
        method: "POST",
        headers: {
            'Content-type': 'application/json',
            'apikey': apikey,
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ user })
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}user/register`, requestOptions).then(async response => {
        statusCode = response?.status;
        apiResponse = await response.json();
        if (statusCode === 401 && apiResponse.message === 'Error verifying token : jwt expired') {
            localStorage.removeItem("userData")
            History.push('/login');
        }
        else if (statusCode !== 200) {
            user.Password = orignalPassword
            user.allowedServiceOpt = originalallowedServiceOpt
        }
    }).catch(error => {
        if (error) {
            user.Password = orignalPassword;
            user.allowedServiceOpt = originalallowedServiceOpt;
        }
        return false;
    })
    if (apiResponse) {
        return apiResponse;
    }
}


export const getAllUserData = async (apikey, token) => {
    let statusCode;
    let apiResponse;

    const requestOptions = {
        method: "GET",
        headers: {
            'Content-type': 'application/json',
            'apikey': apikey,
            'Authorization': `Bearer ${token}`,
        }
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}user/getSbxProdUsers`, requestOptions).then(async response => {
        statusCode = response?.status;
        apiResponse = await response.json()
        if (statusCode === 401 && apiResponse.message === 'Error verifying token : jwt expired') {
            localStorage.removeItem("userData")
            History.push('/login');
        }
    }).catch(error => {
        if (statusCode === 401) {
            localStorage.removeItem("userData")
            History.push('/login')
        }
        return false;
    })
    if (apiResponse) {
        return apiResponse
    }
}


export const updateRegionAccess = async (apikey, token, body) => {
    let statusCode;
    let apiResponse;
    const requestOptions = {
        method: "PUT",
        headers: {
            'Content-type': 'application/json',
            'apikey': apikey,
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(body)
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}user/editRegionAccessList`, requestOptions).then(async response => {
        statusCode = response?.status;
        apiResponse = await response.json();
        if (statusCode === 401 && apiResponse.message === 'Error verifying token : jwt expired') {
            localStorage.removeItem("userData")
            History.push('/login');
        }
    }).catch(error => {
        if (statusCode === 401) {
            localStorage.removeItem("userData")
            History.push('/login')
        }
        return false;
    })
    if (apiResponse) {
        return apiResponse;
    }
}

export const updateUser = async (apikey, user, token) => {
    let statusCode;
    let apiResponse;
    const newUser = {
        FirstName: user?.FirstName,
        LastName: user?.LastName,
        Email: user?.Email,
        ApiCount: user?.ApiCount,
        Modified: new Date(),
        AccessFields: user?.AccessFields,
        RouteAccess: user?.RouteAccess,
        UserEndDate: user?.UserEndDate,
        StartDate: user?.StartDate,
        EndDate: user?.EndDate,
        Id: user?.Id,
        AllowedPdfExport: user?.AllowedPdfExport,
        AllowedExcelExport: user?.AllowedExcelExport,
        PreviousEndDate: user?.PreviousEndDate,
        PreviousApiCount: user?.PreviousApiCount,
        Comment: user?.Comment ?? '',
        Active: user?.Active === true ? 1 : 0
    }
    const requestOptions = {
        method: "POST",
        headers: {
            'Content-type': 'application/json',
            'apikey': apikey,
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(newUser)
    }

    await fetch(`${process.env.REACT_APP_VIO_SERVICE}user/updateUser`, requestOptions).then(async response => {
        statusCode = response?.status;
        apiResponse = await response.json();
        if (statusCode === 401 && apiResponse.message === 'Error verifying token : jwt expired') {
            localStorage.removeItem("userData")
            History.push('/login');
        }
    }).catch(error => {
        if (statusCode === 401) {
            localStorage.removeItem("userData")
            History.push('/login')
        }
        return false;
    })
    if (apiResponse) {
        return apiResponse;
    }
}


export const updateUserProfile = async (apikey, user, token) => {
    let statusCode;
    let apiResponse;
    const newUser = {
        FirstName: user?.FirstName,
        LastName: user?.LastName,
        Company: user?.Company
    }
    const requestOptions = {
        method: "POST",
        headers: {
            'Content-type': 'application/json',
            'apikey': apikey,
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(newUser)
    }

    await fetch(`${process.env.REACT_APP_VIO_SERVICE}user/updateUserProfile`, requestOptions).then(async response => {
        statusCode = response?.status;
        apiResponse = await response.json();
        if (statusCode === 401 && apiResponse.message === 'Error verifying token : jwt expired') {
            localStorage.removeItem("userData")
            History.push('/login');
        }
    }).catch(error => {
        if (statusCode === 401) {
            localStorage.removeItem("userData")
            History.push('/login')
        }
        return false;
    })
    if (apiResponse) {
        if (apiResponse && apiResponse.status && apiResponse.status === 200 && apiResponse.data && apiResponse.data.Token && apiResponse.data.Token.length > 0) {
            localStorage.setItem("userData", encryptData(JSON.stringify(apiResponse.data)))
            return apiResponse
        }
        else return apiResponse;
    }
}


export const updateUserPassword = async (apikey, bodyData, token) => {
    let statusCode;
    let apiResponse;
    const body = {
        CurrentPassword: btoa(bodyData?.CurrentPassword),
        NewPassword: btoa(bodyData?.NewPassword),
        RepeatNewPassword: btoa(bodyData?.RepeatNewPassword)
    }
    const requestOptions = {
        method: "POST",
        headers: {
            'Content-type': "application/json",
            "apikey": apikey,
            "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(body)
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}user/updatePassword`, requestOptions).then(async repsonse => {
        statusCode = repsonse?.status;
        apiResponse = await repsonse.json()
        if (statusCode === 401 && apiResponse.message === 'Error verifying token : jwt expired') {
            localStorage.removeItem("userData")
            History.push('/login')
            return false
        }
    }).catch((error) => {
        if (statusCode === 401) {
            localStorage.removeItem("userData")
            History.push('/login')
        }
        return false
    })
    if (apiResponse) {
        return apiResponse
    }
}


export const resetUserPassword = async (apikey,bodyData, token) => {
    let statusCode;
    let apiResponse;
    const body = {
        NewPassword: btoa(bodyData?.NewPassword),
        RepeatNewPassword: btoa(bodyData?.RepeatNewPassword)
    }
    const requestOptions = {
        method: "POST",
        headers: {
            'Content-type': "application/json",
            "apikey": apikey,
            "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(body)
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}user/resetPassword`, requestOptions).then(async repsonse => {
        statusCode = repsonse?.status;
        apiResponse = await repsonse.json()
        if (statusCode === 401 && apiResponse.message === 'Error verifying token : jwt expired') {
            localStorage.removeItem("userData")
            History.push('/login')
            return false
        }
    }).catch((error) => {
        if (statusCode === 401) {
            localStorage.removeItem("userData")
            History.push('/login')
        }
        return false
    })
    if (apiResponse) {
        return apiResponse
    }
}

export const verifyResetToken = async (token, apikey) => {
    let statusCode;
    let apiResponse;
    const requestOptions = {
        method: "POST",
        headers: new Headers({
            'Content-type': "application/json",
            'apikey': apikey,
            "Authorization": `Bearer ${token}`
        }),
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}user/verifyResetToken`, requestOptions).then(async repsonse => {
        statusCode = repsonse?.status;
        apiResponse = await repsonse.json()
        if (statusCode === 401 && apiResponse.message === 'Error verifying token : jwt expired') {
            localStorage.removeItem("userData")
            return apiResponse
        }
    }).catch((error) => {
        if (statusCode === 401) {
            localStorage.removeItem("userData")
            History.push("/login")
        }
        return false
    })
    if (apiResponse) {
        return apiResponse
    }
}



export const getCommentHistory = async (apikey, userId, token) => {
    let statusCode;
    let apiResponse;
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('apikey', apikey);
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}user/UserHistory?userId=${userId}`, requestOptions)
        .then(async response => {
            statusCode = response.status;
            apiResponse = await response.json();
            if (statusCode === 401 && apiResponse.message === 'Error verifying token : jwt expired') {
                localStorage.removeItem("userData")
                History.push('/login');
            }
        })
        .catch(error => {
            return false;
        });

    if (apiResponse) {
        return apiResponse;
    }
};

export const getUserDownloadHisotry = async (apikey, token) => {
    let statusCode;
    let apiResponse;
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('apikey', apikey);
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    }
    await fetch(`${process.env.REACT_APP_VIO_SERVICE}user/GetHistory`, requestOptions).then(async response => {
        statusCode = response.status;
        apiResponse = await response.json();
        if (statusCode === 401 && apiResponse.message === 'Error verifying token : jwt expired') {
            localStorage.removeItem("userData")
            History.push('/login');
        }
    })
        .catch(error => {
            return false;
        })

    if (apiResponse) {
        return apiResponse;
    }

}